import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  ConfirmServiceCasePayload,
  CustomerMyServiceCasesDto,
  CustomerServiceCaseDetailDto,
} from '../../../models/customer-service/service-case.model';
import { StatusAPIResponse } from '../../../models/information.model';
@Injectable({
  providedIn: 'root',
})
export class ApiServiceCaseService {
  private privateApiUrl = `${environment.apiPrivateUrl}`;
  constructor(private http: HttpClient) { }
  /*############################################# API #################################################*/
  /**
   * ดึงรายการเรื่องของฉัน (แยก active และ history)
   * GET /CityParking/getMyServiceCases?uid={uid}
   */
  getMyServiceCases(uid: string): Observable<CustomerMyServiceCasesDto> {
    const params = new HttpParams().set('uid', uid);
    return this.http.get<CustomerMyServiceCasesDto>(
      `${this.privateApiUrl}/CityParking/getMyServiceCases`,
      { params },
    );
  }
  /**
   * ดึงรายละเอียดเรื่อง + timeline ที่ลูกค้าเห็นได้
   * GET /CityParking/getMyServiceCaseDetail?uid={uid}&id={id}&caseNo={caseNo}
   */
  getMyServiceCaseDetail(
    uid: string,
    id?: number,
    caseNo?: string,
  ): Observable<CustomerServiceCaseDetailDto> {
    let params = new HttpParams().set('uid', uid);
    if (id !== undefined && id !== null && id > 0) {
      params = params.set('id', id.toString());
    }
    if (caseNo && caseNo.trim() !== '') {
      params = params.set('caseNo', caseNo.trim());
    }
    return this.http.get<CustomerServiceCaseDetailDto>(
      `${this.privateApiUrl}/CityParking/getMyServiceCaseDetail`,
      { params },
    );
  }
  /**
   * ยืนยันปิดเรื่อง (สำหรับเคสเก่าที่ canConfirm = true)
   * POST /CityParking/confirmServiceCase
   */
  confirmServiceCase(
    payload: ConfirmServiceCasePayload,
  ): Observable<StatusAPIResponse> {
    return this.http.post<StatusAPIResponse>(
      `${this.privateApiUrl}/CityParking/confirmServiceCase`,
      payload,
    );
  }
}
